import { Directive, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { take } from 'rxjs/operators';
import { AppLoaderService } from './app-loader.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[loader]',
})
export class AppLoaderDirective implements OnInit {
  @Input() loader = 'preloader';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private appLoaderService: AppLoaderService
  ) {}

  ngOnInit(): void {
    this.appLoaderService.loader$.pipe(take(1)).subscribe(() => {
      this.removeLoader();
    });
  }

  private removeLoader(): void {
    const loader = this.document.getElementById(this.loader);
    if (loader && loader.parentNode) {
      this.renderer.removeChild(loader.parentNode, loader);
    }
  }
}
